export default __webpack_public_path__ + "static/media/Boots of the Bloodmoon.27faa0ca.jpg";